const ELECTRIC_VEHICLE_WEIGHT_ERROR =
  'รถไฟฟ้าต้องระบุน้ำหนักรถเป็นตัวเลขที่มากกว่า 0';

function isElectricFuel(carFuel) {
  return carFuel === 3 || carFuel === '3';
}

function hasValidPositiveWeight(carWeight) {
  if (
    carWeight === null ||
    typeof carWeight === 'undefined' ||
    typeof carWeight === 'boolean' ||
    (typeof carWeight === 'string' && carWeight.trim() === '')
  ) {
    return false;
  }

  const numericWeight = Number(carWeight);
  return Number.isFinite(numericWeight) && numericWeight > 0;
}

function getElectricVehicleWeightError(carFuel, carWeight) {
  if (!isElectricFuel(carFuel) || hasValidPositiveWeight(carWeight)) return '';
  return ELECTRIC_VEHICLE_WEIGHT_ERROR;
}

module.exports = {
  ELECTRIC_VEHICLE_WEIGHT_ERROR,
  isElectricFuel,
  hasValidPositiveWeight,
  getElectricVehicleWeightError,
};
